"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductRegionSchema = exports.MI = exports.CA = exports.AZ = exports.ProductRegion = void 0;
const AZ_1 = __importDefault(require("./AZ"));
const CA_1 = __importDefault(require("./CA"));
const MI_1 = __importDefault(require("./MI"));
var ProductRegion;
(function (ProductRegion) {
    ProductRegion["AZ"] = "AZ";
    ProductRegion["CA"] = "CA";
    ProductRegion["MI"] = "MI";
})(ProductRegion = exports.ProductRegion || (exports.ProductRegion = {}));
exports.AZ = ProductRegion.AZ, exports.CA = ProductRegion.CA, exports.MI = ProductRegion.MI;
exports.ProductRegionSchema = {
    [exports.AZ]: AZ_1.default,
    [exports.CA]: CA_1.default,
    [exports.MI]: MI_1.default,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvanNvblNjaGVtYS9wcm9kdWN0cy9yZWdpb25TY2hlbWFzL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLDhDQUE2QjtBQUM3Qiw4Q0FBNkI7QUFDN0IsOENBQTZCO0FBRTdCLElBQVksYUFJWDtBQUpELFdBQVksYUFBYTtJQUNyQiwwQkFBUyxDQUFBO0lBQ1QsMEJBQVMsQ0FBQTtJQUNULDBCQUFTLENBQUE7QUFDYixDQUFDLEVBSlcsYUFBYSxHQUFiLHFCQUFhLEtBQWIscUJBQWEsUUFJeEI7QUFHRyxVQUFFLEdBR0YsYUFBYSxLQUZiLFVBQUUsR0FFRixhQUFhLEtBRGIsVUFBRSxHQUNGLGFBQWEsSUFBQztBQUVMLFFBQUEsbUJBQW1CLEdBQUc7SUFDL0IsQ0FBQyxVQUFFLENBQUMsRUFBRSxZQUFTO0lBQ2YsQ0FBQyxVQUFFLENBQUMsRUFBRSxZQUFTO0lBQ2YsQ0FBQyxVQUFFLENBQUMsRUFBRSxZQUFTO0NBQ2xCLENBQUMifQ==